import { Grid } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import ListEmpty from '../../components/fragments/ListEmpty';
import Screen from '../../components/fragments/Screen';
import CardHome from '../../components/legacy/CardHome';
import { rtGetListData } from '../../store/slices/listSlice';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    <Box sx={{ width: '100%', height: 56 }} />
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

export default function MinistriesScreen() {
    const [value, setValue] = useState(0);

    const theme = useTheme();
    const dispatch = useDispatch();
    const state = useSelector((st) => st);

    const { ministries, joinedMinistries, busy } = state.list2;

    useEffect(() => {
        dispatch(rtGetListData('departments', 'ministries'));
        dispatch(rtGetListData('departments/joined', 'joinedMinistries'));
    }, [dispatch]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    return (
        <Screen
            loading={busy['ministries'] || busy['joinedMinistries']}
            disablePadding
            disableSpacing
            title="Ministries"
        >
            <AppBar
                style={{
                    position: 'fixed',
                    top: 56,
                    backgroundColor: theme.palette.background.paper,
                    width: '100%',
                    zIndex: 1,
                }}
            >
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="fullWidth"
                    textColor={
                        theme.palette.mode == 'light' ? 'primary' : 'inherit'
                    }
                >
                    <Tab
                        className="text-capitalize fw-bold"
                        label="Church Ministries"
                    />
                    <Tab
                        className="text-capitalize fw-bold"
                        label="My Ministries"
                    />
                </Tabs>
            </AppBar>
            <SwipeableViews
                className="w-100"
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                <TabPanel value={value} index={0} dir={theme.direction}>
                    <Grid container spacing={1} sx={{ px: 1 }}>
                        {!busy['ministries'] && ministries?.length < 1 && (
                            <ListEmpty />
                        )}
                        {ministries?.map(({ id, name, notes }) => (
                            <CardHome
                                full
                                key={id}
                                title={name}
                                link={{
                                    pathname: `/ministry/${id}`,
                                    state: { id, name, notes },
                                }}
                                state={{ id, name, notes }}
                            />
                        ))}
                    </Grid>
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                    <Grid container spacing={1} sx={{ px: 1 }}>
                        {joinedMinistries?.map(({ id, name, notes }) => (
                            <CardHome
                                full
                                key={id}
                                title={name}
                                link={{
                                    pathname: `/ministry/${id}`,
                                    state: { id, name, notes },
                                }}
                            />
                        ))}
                        {!busy['ministries'] && ministries?.length < 1 && (
                            <ListEmpty />
                        )}
                    </Grid>
                </TabPanel>
            </SwipeableViews>
        </Screen>
    );
}
